export default __webpack_public_path__ + "static/media/linkedin.76025f64.jpg";